var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesBannerTablet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 658,
    viewBox: "0 0 834 658",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.494 409.424C661.122 496.116 747.162 578.879 639.559 614.881C531.955 650.884 300.755 584.081 185.39 488.949C70.0243 393.817 65.2997 286.5 98.7655 222.913C132.231 159.325 235.796 160.977 332.955 211.228C430.114 261.479 628.564 50.4279 711.533 133.72C794.502 217.012 698.574 319.388 679.494 409.424Z",
    fill: "#72BEB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 329.21C0 329.21 338.004 318.136 401.349 284.766C464.694 251.397 533.836 183.216 606.836 186.088C679.836 188.96 704.435 240.591 695.707 284.766C686.978 328.942 632.923 358.908 564.337 383.622C495.75 408.336 327.003 389.824 327.003 389.824C327.003 389.824 221.322 380.597 205.953 411.532C190.584 442.468 195.81 475.811 269.34 507.365C342.87 538.918 528.118 496.297 528.118 496.297C528.118 496.297 709.263 429.86 834 437.805",
    stroke: "#EAE7DE",
    strokeWidth: 3,
    strokeDasharray: "15 10"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBannerTablet);
export default __webpack_public_path__ + "static/media/servicesBannerTablet.3b79097ec8a0e61e0dfe1d1db2d6fc41.svg";
export { ForwardRef as ReactComponent };